export default __webpack_public_path__ + "assets/icons/file-delete.fd51b505.svg";